module.exports = __webpack_public_path__ + "img/zaf.14e70522.svg";